import { createMachine, assign, sendParent } from 'xstate'
import { choiceMachineContext } from '../utils/machine_utils/ChoiceMachines.utils'
import { inputEvents, questionEvents } from '../events/eventMap'

const setErrorMessage = (errorMessage) => {
  const errors = []
  if (errorMessage) {
    errors.push(errorMessage)
  }
  return {
    errors
  }
}

export const singleChoiceGroupDefinition = {
  id: 'radioGroup',
  initial: 'initial',
  predictableActionArguments: true,
  context: {
    ...choiceMachineContext,
    isSingleClick: false
  },
  on: {
    [inputEvents.select]: [{
      actions: ['selectValue', 'selectSliderInputValue', 'sendValueToParent'],
      cond: 'isSlider'
    }, {
      actions: ['selectValue', 'sendPopupDataToParent', 'sendValueToParent'],
      cond: 'checkPopupData'
    }, {
      actions: ['selectValue', 'sendValueToParent']
    }],
    [inputEvents.validate]: [
      {
        target: 'valid',
        cond: 'checkRequirement',
        actions: 'clearErrors'
      },
      {
        target: 'invalid',
        actions: 'setErrors'
      }
    ]
  },
  states: {
    initial: {
      entry: 'sendPopupDataToParent',
      cond: 'checkPopupData'
    },
    valid: {
      tags: ['valid'],
      entry: 'broadcastValid'
    },
    invalid: {
      entry: 'broadcastInvalid'
    }
  }
}

export const singleChoiceGroupOptions = {
  actions: {
    selectValue: assign({
      selected: (ctx, event) => ctx.isSingleClick ? null : event.value,
      value: (ctx, event) => event.value
    }),
    selectSliderInputValue: assign((ctx, event) => {
      return {
        slider_options: {
          ...ctx.slider_options,
          slider_input_value: event.data.inputValue
        }
      }
    }),
    setErrors: assign(ctx => setErrorMessage(ctx.errorMessage)),
    clearErrors: assign(setErrorMessage()),
    sendPopupDataToParent: sendParent(ctx => {
      const selectedAnswer = ctx.answer_choices.find(answerChoice => answerChoice.value === ctx.selected)

      return {
        type: questionEvents.updatePopupURL,
        data: {
          popup_url: selectedAnswer?.popup_url,
          popup_url_target: selectedAnswer?.popup_url_target
        }
      }
    }),
    sendValueToParent: sendParent(ctx => ({
      type: questionEvents.updateAnswer,
      data: {
        id: ctx.id,
        groupKey: ctx.groupKey,
        value: ctx.value
      }
    })),
    broadcastValid: sendParent(ctx => ({
      type: questionEvents.valid,
      data: {
        id: ctx.id,
        groupKey: ctx.groupKey,
        errors: ctx.errors
      }
    })),
    broadcastInvalid: sendParent(ctx => ({
      type: questionEvents.invalid,
      data: {
        id: ctx.id,
        groupKey: ctx.groupKey,
        errors: ctx.errors
      }
    }))
  },
  guards: {
    checkRequirement: ctx => !ctx.required || !!ctx.selected,
    checkPopupData: (ctx, event) => {
      const selectedAnswer = ctx.answer_choices.find(answerChoice =>
        answerChoice.value === event.value)
      if (selectedAnswer.popup_url === undefined) {
        selectedAnswer.popup_url = ''
        selectedAnswer.popup_url_target = ''
      }
      return true
    },
    isSlider: ctx => ctx.slider_options
  }
}

export const singleChoiceGroupMachine = createMachine(singleChoiceGroupDefinition, singleChoiceGroupOptions)
